/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      console.log('Container ———————— ↓');
      console.log(container);
      console.log('Variant —————————— ↓');
      console.log(variant);
      // ... update some element on the page
    }
  });

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log('Cart ———————————— ↓');
      console.log(cart);
      // ... update an app or a custom shipping caluclator
    }
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    console.log('theme:cart:init');
    console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  document.addEventListener('theme:scroll', e => { console.log(e); });
  document.addEventListener('theme:scroll:up', e => { console.log(e); });
  document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

  class ShippingProtectionToggle extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('input');
        this.onLoad();
        this.setupEventListeners();
      }

      async onLoad() {
        const cart = await this.getCart();
        const isProtectionProductInCart = cart.items.some(item => item.variant_id == this.dataset.id);
        if (isProtectionProductInCart){
          this.input.checked = true;
        } else {
          this.input.checked = false;
        }
      }

      setupEventListeners() {
        this.input.addEventListener('change', this.onChange.bind(this))
      }

      async onChange(e) {
        console.log(e);
        console.log(this.input.checked);
        var productInput = document.querySelector('.protection_product');
        var variantId = productInput.getAttribute('data-variant-id');
        if(this.input.checked){
          await this.addToCartIfNotInCart(variantId);
        }
        else{
          await this.removeFromCart(variantId);
        }
      }
      
      addToCartIfNotInCart(variantId) {
            $.ajax({
                type: 'GET',
                url: '/cart.js',
                dataType: 'json',
                success: (cart) => {
                    var itemInCart = cart.items.some(function(item) {
                        return item.variant_id == variantId;
                    });

                    if (!itemInCart) {
                        this.addToCart(variantId);
                    } else {
                        console.log("Item is already in the cart: " + variantId);
                    }
                },
                error: function(error) {
                    console.error("Error retrieving cart:", error);
                }
            }); 
        }

       addToCart(variantId) {
            $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                data: {
                    id: variantId.toString(),
                    quantity: 1
                },
                dataType: 'json',
                success: function(response) {
                   document.dispatchEvent(new CustomEvent('theme:cart:reload', {bubbles: true}));
                },
                error: function(error) {
                    console.error("Error adding to cart:", error);
                }
            });
        }
      
        async removeFromCart(variantId) {
          document.querySelector('[data-productid="48121165185364"] .cart__items__remove a').click();
            // $.ajax({
            //     type: 'POST',
            //     url: '/cart/change.js',
            //     data: {
            //         id: variantId,
            //         quantity: 0
            //     },
            //     dataType: 'json',
            //     success: function(response) {
            //       console.log({ response })
            //        document.dispatchEvent(new CustomEvent('theme:cart:change', {detail: response}));
            //     },
            //     error: function(error) {
            //         console.error("Error removing from cart:", error);
            //     }
            // });
        }

      getCart() {
        const url = `${window.theme.routes.cart}.js`;
      
        return fetch(url)
        .then(response => {
          return response.json();
        })
        .catch(error => {
          console.error('Error fetching cart count:', error);
        });
      }
    
    }

    customElements.define("shipping-protection-toggle", ShippingProtectionToggle);
})();
